import graph from "../Assets/Icons/graph.png";
import table from "../Assets/Icons/table4.svg";
// import table from "../Assets/Icons/table.png";
import menu from "../Assets/Icons/menu.svg";
import menuStatus from "../Assets/Icons/menuStatus.svg";
import menuEdit from "../Assets/Icons/menuEdit.svg";
import users from "../Assets/Icons/users.svg";
import settings from "../Assets/Icons/settings.svg";
import notification from "../Assets/Icons/notification.svg";
import reserved from "../Assets/Icons/reserved.svg";
import categories from "../Assets/Icons/categories.svg";
import takeaway from "../Assets/Designer.png";
import orders from "../Assets/Icons/orders.svg";
import onlineOrders from "../Assets/online-order.png"
import dashboard from "../Assets/dashboard.png"
import updated from "../Assets/updated.png"
import greenCart from "../Assets/greenCart.png"
import cart from "../Assets/cart.png"
import yellowCart from "../Assets/yellowCart.png"
import serviceBell1 from "../Assets/serviceBell1.png"
import reservation from "../Assets/reservation.png"
import note from "../Assets/note.png"
import qrCode1  from "../Assets/QRCode.png"
import calculator from  "../Assets/calculator.png"
import ca from  "../Assets/ca.png"
import resto from  "../Assets/resto.png"
import tax from "../Assets/tax.png"
import restaurant from "../Assets/restaurant.png"
import qrcode from "../Assets/qrcode (2).png"

// todo:
// login - User Type
// U0 - Owner
// U1 - Admin
// U2 - Manager
// U3 - staff
// BA - Business analyst - only graph and report [Read Only]
// unknown user - transfer to 404 [which has list of directive] - plain HTML page



// const admindata = [
//     {
//         id: 1,
//         title:'Dashboard',
//         navigateTo: 'dashboard', // analysis,
//         imageUrl: dashboard, // 'https://via.placeholder.com/150/FFC107/000000?Text=Products',
//         altText: 'View Analysis',
//         role: "Admin"
//     },
//     {
//         id: 2,
//         title:'Table Screen',
//         navigateTo: 'tables',
//         imageUrl: table, // 'https://via.placeholder.com/150/4CAF50/FFFFFF?Text=Services',
//         altText: 'tables',
//         role: "staff"
//     },
//     {
//         id: 3,
//         title:'Place Orders',
//         navigateTo: 'menu',
//         imageUrl: onlineOrders, // 'https://via.placeholder.com/150/2196F3/FFFFFF?Text=About',
//         altText: 'Order for specific table. On customer behalf. Manager can delete/cancel the order with resolution comment (optional).',
//         role: "staff"
//     },
//     {
//         id: 4,
//         title:'Item Availabilities',
//         navigateTo: 'menu-status',
//         imageUrl: menuStatus, // 'https://via.placeholder.com/150/F44336/FFFFFF?Text=Contact',
//         altText: 'Update the availability of items',
//         role: "manager"
//     },
//     {
//         id: 5,
//         title:'Update Menus',
//         navigateTo: 'menu-alter',
//         imageUrl: updated, // 'https://via.placeholder.com/150/9C27B0/FFFFFF?Text=Gallery',
//         altText: 'Add, edit, delete the menu item. It inclues Name, price, image and description.',
//         role: "Admin"
//     },
//     {
//         id: 6,
//         title:'Users',
//         navigateTo: 'user-alter',
//         imageUrl: users, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the users. It inclues Name, role and other details.',
//         role: "Admin"
//     },
//     {
//         id: 7,
//         title:'Live KOT',
//         navigateTo: 'live-order',
//         imageUrl: greenCart, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the users. It inclues Name, role and other details.',
//         role: "Admin"
//     },
//     {
//         id: 7,
//         title:'Cancelled KOT',
//         navigateTo: 'order-cancelled',
//         imageUrl: cart, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the users. It inclues Name, role and other details.',
//         role: "Admin"
//     },
//     {
//         id: 7,
//         title:'History KOT',
//         navigateTo: 'order-history',
//         imageUrl: yellowCart, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the users. It inclues Name, role and other details.',
//         role: "Admin"
//     },
//     {
//         id: 8,
//         title:'Categories & Foods',
//         navigateTo: 'menu-categories',
//         imageUrl: categories, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the category and its food item. It inclues Name and other details.',
//         role: "Admin"
//     },{
//         id: 9,
//         title:'Bills',
//         navigateTo: 'bills',
//         imageUrl: note, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the category and its food item. It inclues Name and other details.',
//         role: "Admin"
//     },
//     {
//         id: 11,
//         title:'Waiter Request',
//         navigateTo: 'waiterRequest',
//         imageUrl: serviceBell1, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the category and its food item. It inclues Name and other details.',
//         role: "Admin"
//     },{
//         id: 10,
//         title:'Reservation',
//         navigateTo: 'reservation',
//         imageUrl: reservation, // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//         altText: 'Add, edit, delete the category and its food item. It inclues Name and other details.',
//         role: "Admin"
//     }
//     // },{
//     //     id: 12,
//     //     title:'Notification',
//     //     navigateTo: 'notification',
//     //     imageUrl: "/bell.png", // 'https://via.placeholder.com/150/607D8B/FFFFFF?Text=Blog',
//     //     altText: 'Add, edit, delete the category and its food item. It inclues Name and other details.',
//     //     role: "Admin"
//     // }
// ];

const admindata = [
    {
        id: 1,
        title: 'Dashboard',
        navigateTo: 'dashboard',
        imageUrl: dashboard,
        altText: 'View Analysis',
        feature: "dashboard" // Sidebar & Route permissions se match karne ke liye
    },
    {
        id: 2,
        title: 'Table Screen',
        navigateTo: 'tables',
        imageUrl: table,
        altText: 'tables',
        feature: "tables"
    },
    {
        id: 3,
        title: 'TakeAway Orders',
        navigateTo: 'takeaway/new',
        imageUrl: takeaway,
        altText: 'Manage take-away orders',
        feature: "takeaway-orders"
    },{
        id: 4,
        title: 'Place Orders',
        navigateTo: 'menu',
        imageUrl: onlineOrders,
        altText: 'Order for specific table...',
        //feature: "menu"
        feature: "placeOrder"
    },
    {
        id: 4,
        title: 'Item Availabilities',
        navigateTo: 'menu-status',
        imageUrl: menuStatus,
        altText: 'Update the availability of items',
        feature: "menu"
    },
    {
        id: 7,
        title: 'Live KOT',
        navigateTo: 'live-order',
        imageUrl: greenCart,
        altText: 'Live kitchen order tickets',
        feature: "KOT"
    },
    {
        id: 8,
        title: 'Cancelled KOT',
        navigateTo: 'order-cancelled',
        imageUrl: cart,
        altText: 'Cancelled kitchen order tickets',
        feature: "KOT"
    },
    {
        id: 9,
        title: 'History KOT',
        navigateTo: 'order-history',
        imageUrl: yellowCart,
        altText: 'Past history of kitchen order tickets',
        feature: "KOT"
    },
    {
        id: 10,
        title: 'Categories & Foods',
        navigateTo: 'menu-categories',
        imageUrl: categories,
        altText: 'Add, edit, delete the category and food items',
        feature: "menu"
    },
    {
        id: 11,
        title: 'Bills',
        navigateTo: 'bills',
        imageUrl: note,
        altText: 'Manage billing and receipts',
        feature: "bills"
    },
    {
        id: 12,
        title: 'Waiter Request',
        navigateTo: 'waiterRequest',
        imageUrl: serviceBell1,
        altText: 'Customer assistance requests',
        feature: "waiterRequest"
    },
    {
        id: 13,
        title: 'Reservation',
        navigateTo: 'reservation',
        imageUrl: reservation,
        altText: 'Table booking configurations',
        feature: "reservation"
    },
    {
        id: 14,
        title: 'Add/Edit Table',
        navigateTo: 'table-setting',
        imageUrl: updated,
        altText: 'Add, edit, delete the table...',
        feature: "table-setting"
    },{
        id: 15,
        title: 'Tax Calculation',
        navigateTo: 'tax-setting',
        imageUrl: tax,
        altText: 'Add, edit, delete the table...',
        feature: "staff"
    },{
        id: 16,
        title: 'Restaurant Profile',
        navigateTo: 'restaurant-setting',
        imageUrl: restaurant,
        altText: 'Add, edit, delete the table...',
        feature: "staff"
    },
    {
        id: 5,
        title: 'QR Menu',
        navigateTo: 'qr-code',
        imageUrl: qrcode,
        altText: 'Add, edit, delete the menu item...',
        feature: "qr-code"
    },
    {
        id: 6,
        title: 'Users',
        navigateTo: 'user-alter',
        imageUrl: users,
        altText: 'Add, edit, delete the users...',
        feature: "staff"
    }
];

const restaurantData = [
    {
        id: 101,
        restaurantId: 'bengaluru-biryani-house-001',
        locationId: 'bengaluru-koramangala',
    },
    {
        id: 102,
        restaurantId: 'mysore-darshini-central',
        locationId: 'mysore-davanagere',
    },
    {
        id: 103,
        restaurantId: 'hubballi-joshis-north',
        locationId: 'hubballi-vidyanagar',
    },
    {
        id: 104,
        restaurantId: 'mangaluru-fish-land-main',
        locationId: 'mangaluru-kadri',
    },
    {
        id: 105,
        restaurantId: 'belagavi-khanavali-corner',
        locationId: 'belagavi-tilakwadi',
    },
];

const tableData = [
    { name: 'T-1', id: 1, status: "Empty", code:"333" },
    { name: 'T-2', id: 2, status: "BillingRequested", code:"126"},
    { name: 'T-3', id: 3, status: "Occupied", code:"323" },
    { name: 'T-4', id: 4, status: "Occupied" , code:"133"},
    { name: 'T-5', id: 5, status: "BillingRequested", code:"123" },
    { name: 'T-6', id: 6, status: "Empty", code:"124" },
    { name: 'T-7', id: 7, status: "BillingRequested", code:"125" },
    { name: 'T-8', id: 8, status: "Occupied", code:"126" },
    { name: 'T-9', id: 9, status: "Occupied", code:"127" },
    { name: 'T-10', id: 10, status: "BillingRequested", code:"128" },
    { name: 'T-11', id: 11, status: "Empty" , code:"129"},
    { name: 'T-12', id: 12, status: "Reserved" , code:"130"},
    { name: 'T-13', id: 13, status: "Occupied", code:"131" },
    { name: 'T-14', id: 14, status: "Occupied", code:"133" },
    { name: 'T-15', id: 15, status: "BillingRequested" },
    { name: 'T-16', id: 16, status: "Empty", code:"132" },
    { name: 'T-17', id: 17, status: "Reserved", code:"123" },
    { name: 'T-18', id: 18, status: "Occupied", code:"222" },
    { name: 'T-19', id: 19, status: "Occupied", code:"553" },
    { name: 'T-20', id: 20, status: "BillingRequested", code:"123" },
    { name: 'T-21', id: 21, status: "Empty", code:"113" },
    { name: 'T-22', id: 22, status: "Reserved", code:"023" },
    { name: 'T-23', id: 23, status: "Occupied", code:"103" },
    { name: 'T-24', id: 24, status: "Occupied", code:"120" },
    { name: 'T-25', id: 25, status: "Occupied", code:"143" },
    { name: 'T-26', id: 25, status: "Occupied", code:"153" },
    { name: 'T-27', id: 25, status: "Occupied", code:"223" },
    { name: 'T-28', id: 25, status: "Occupied", code:"323" },
    { name: 'T-29', id: 25, status: "Occupied", code:"423" },
    { name: 'T-30', id: 25, status: "BillingRequested", code:"523" },
    { name: 'T-31', id: 25, status: "Occupied", code:"623" },
    { name: 'T-32', id: 25, status: "BillingRequested", code:"723" },
    { name: 'T-33', id: 25, status: "Empty", code:"823" },
    { name: 'T-34', id: 25, status: "Empty", code:"923" },
    { name: 'T-35', id: 25, status: "Empty", code:"553" },
    { name: 'T-36', id: 25, status: "Occupied", code:"663" },
    { name: 'T-37', id: 25, status: "Occupied", code:"773" },
    { name: 'T-38', id: 25, status: "BillingRequested", code:"883" },
    { name: 'T-39', id: 25, status: "Occupied", code:"993" },
    { name: 'T-40', id: 25, status: "Empty", code:"103" },
    { name: 'T-41', id: 25, status: "Empty", code:"003" },
    {name: 'T-42', id: 25, status: "Empty", code:"103" },
    { name: 'T-43', id: 25, status: "Maintenance", code:"003" },
    { name: 'T-44', id: 25, status: "Maintenance", code:"103" },
    { name: 'T-45', id: 25, status: "BillingRequested", code:"003" },
    {name: 'T-46', id: 25, status: "BillingRequested", code:"103" },
    { name: 'T-47', id: 25, status: "Maintenance", code:"003" },
    { name: 'T-48', id: 25, status: "Occupied", code:"103" },
    { name: 'T-49', id: 25, status: "Empty", code:"003" },
    {name: 'T-50', id: 25, status: "BillingRequested", code:"103" },
    { name: 'T-51', id: 25, status: "Maintenance", code:"104" },
    { name: 'T-52', id: 25, status: "Maintenance", code:"204" },
    { name: 'T-53', id: 25, status: "Maintenance", code:"304" },
    { name: 'T-54', id: 25, status: "Maintenance", code:"404" },
    { name: 'T-55', id: 25, status: "Maintenance", code:"504" },
    { name: 'T-56', id: 56, status: "Maintenance", code:"604" }


];

const userList = {
    '1': { id: 1, name: 'John Doe', role: 'Admin', phone: '1234567890', email: 'John@test.com'},
    '2': { id: 2, name: 'Jane Smith', role: 'Manager', phone: '0987654321', email: 'Jane@test.com' },
    '3': { id: 3, name: 'Alice Johnson', role: 'Staff', phone: '1122334455', email: 'Alice@test.com' },
    '4': { id: 4, name: 'Bob Brown', role: 'Owner', phone: '5566778899', email: 'Bob@test.com' },
};

const loggedInUser = {
    id: 1,
    name: 'John Doe',
    roleId: 'Admin',
    phone: '1234567890',
    userName: '',
    restaurantId: 'bengaluru-biryani-house-001',
    locationId: 'bengaluru-koramangala',
};

export { admindata, restaurantData, tableData, userList, loggedInUser };